import React, { useEffect, useState } from "react";
import ARQUITECTURAS from "../seguridad/todas";
import Diagrama from "../Diagrama";

// Linea de tiempo de un incidente: lo mismo con respuesta automatica y con respuesta manual. Los tiempos son ILUSTRATIVOS, para comparar el orden de magnitud.
// «paso» es el paso de la arquitectura «incidentes» que se anima en cada momento.
export const LINEAS = {
    auto: { titulo: "Con detección y respuesta automática", color: "#1d8102", pasos: [
        { t: "0 s", paso: 0, texto: "Alguien usa una credencial robada en uno de tus servidores y empieza a hacer cosas raras." },
        { t: "≈ 1 min", paso: 1, texto: "GuardDuty detecta el comportamiento anómalo y genera un hallazgo." },
        { t: "≈ 1 min", paso: 2, texto: "EventBridge recibe el hallazgo y dispara a la vez la respuesta y el aviso." },
        { t: "≈ 2 min", paso: 3, texto: "Una función Lambda aísla el servidor (le cambia el grupo de seguridad). El atacante pierde el acceso." },
        { t: "≈ 5 min", paso: 3, texto: "El equipo de seguridad ya tiene la alerta y empieza a investigar con el servidor aislado y preservado." }] },
    manual: { titulo: "Sin automatización: alguien tiene que darse cuenta", color: "#d13212", pasos: [
        { t: "0 s", paso: 0, texto: "Alguien usa una credencial robada en uno de tus servidores y empieza a hacer cosas raras." },
        { t: "horas o días", paso: 0, texto: "Nadie lo ve: no hay detección continua. El atacante explora y copia datos con calma." },
        { t: "≈ 1 día", paso: 1, texto: "Un cliente o la factura de AWS delata algo raro, o por fin se revisa un registro." },
        { t: "≈ 1 día + horas", paso: 2, texto: "Se busca a la persona que sepa qué hacer y se discute qué servidor apagar." },
        { t: "≈ 2 días", paso: 3, texto: "Se aísla el servidor a mano. Para entonces el daño ya está hecho." }] },
};

const Incidente = () => {
    const arq = ARQUITECTURAS.find(a => a.id === "incidentes");
    const [modo, setModo] = useState("auto");
    const [k, setK] = useState(0);
    const linea = LINEAS[modo];
    useEffect(() => { setK(0); }, [modo]);
    return (
        <div className="card mb-3" style={{ borderTop: "4px solid #d13212" }} data-guia="incidente">
            <div className="card-body">
                <div className="text-muted small mb-1"><i className="fa fa-stopwatch me-1" />Línea de tiempo</div>
                <h4>Un incidente, minuto a minuto</h4>
                <p className="text-muted">Compara cuánto tarda en contenerse un incidente con y sin detección y respuesta automáticas. <b>Los tiempos son ilustrativos</b>; lo que importa es el orden de magnitud.</p>
                <div className="btn-group mb-3" role="group" aria-label="Escenario">
                    {Object.entries(LINEAS).map(([id, l]) => <button key={id} className={`btn btn-sm ${modo === id ? "btn-primary" : "btn-outline-secondary"}`} aria-pressed={modo === id} onClick={() => setModo(id)}>{id === "auto" ? "Con automatización" : "Sin automatización"}</button>)}
                </div>
                <h5 style={{ color: linea.color }}>{linea.titulo}</h5>
                <input type="range" className="form-range" min={0} max={linea.pasos.length - 1} value={k} onChange={e => setK(Number(e.target.value))} aria-label="Momento del incidente" />
                <ol className="list-unstyled">
                    {linea.pasos.map((p, i) => (
                        <li key={i} className={`d-flex align-items-start p-2 rounded mb-1 ${i === k ? "border" : ""}`} style={{ cursor: "pointer", opacity: i <= k ? 1 : 0.45, borderColor: linea.color }} onClick={() => setK(i)}>
                            <span className="badge me-2 mt-1" style={{ background: linea.color, minWidth: 90 }}>{p.t}</span><span>{p.texto}</span>
                        </li>
                    ))}
                </ol>
                {arq && <Diagrama patron="libre" nodos={arq.nodos} flujosLibres={arq.flujos} grupos={arq.grupos} color={linea.color} paso={linea.pasos[k].paso} />}
            </div>
        </div>
    );
};

export default Incidente;
